<ngb-toast
  *ngFor="let toast of toastService.toasts"
  [class]="toast.classname"
  [autohide]="toast.delay === 0 ? false : true"
  [delay]="toast.delay || 5000"
  (hidden)="toastService.remove(toast)">
  <div class="d-flex" [ngClass]="{ 'no-body': !toast.body.length }">
    <div class="toast-content">
      <strong class="me-auto">{{ toast.title }}</strong>
      <ng-template [ngIf]="isTemplate(toast)" [ngIfElse]="text">
        <ng-template [ngTemplateOutlet]="toast.body"></ng-template>
      </ng-template>

      <ng-template #text>
        @if (toast.body.length) {
          <div class="toast-body" [innerHTML]="toast.body"></div>
        }
      </ng-template>
    </div>
    <button class="btn-close no-img" (click)="toastService.remove(toast)" type="button">
      <img src="assets/images/close-icon.svg" alt="close icon" />
    </button>
  </div>
</ngb-toast>
